<template>
  <div>
    <UserInfo
      :user="user"
      :allowMethodCreation="false"
      :showEditLink="showEditLink"
    ></UserInfo>

    <CardsListUser
      :title="'Методы'"
      :userId="user.id"
      :showFraza="false"
    ></CardsListUser>

    <CardsList
      :title="'Выбранные методы'"
      :cards="user.favorite_cards"
    ></CardsList>
  </div>
</template>

<script>
import UserInfo from "@/components/UserInfo.vue";
import CardsListUser from "@/components/CardsListUser.vue";
import CardsList from "@/components/CardsList.vue";
import { mapGetters } from 'vuex';
import store from "@/store";

export default {
  components: {
    UserInfo, CardsListUser, CardsList
  },
  props: {
    id: { type: Number, default: 0 }
  },
  computed: {
    ...mapGetters(['currentUser']),
    user() {
      return this.$store.getters.user(this.id);
    },
    showEditLink() {
      console.log('showEditLink user', this.user)
      return this.currentUser.role == 'admin' || this.user.id == this.currentUser.id;
    }
  },
  beforeRouteEnter: async function (to, from, next) {
    await Promise.all(
      [
        store.dispatch('loadUser', to.params.id),
        store.dispatch('loadCardsByUser', {userId: to.params.id, type: 'visible'})
      ]
    );
    next();
  },
};
</script>
